import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { PermissionAliasEnum } from '@connect-services/client/sdk/api';
import { HasPermissionsService, OperatorEnum } from '@connect-services/client/services/has-permissions.service';

@Directive({
    selector: '[hasSomePermissions]',
    standalone: true,
})
export class HasSomePermissionsDirective {
    public constructor(
        private hasPermissionService: HasPermissionsService,
        private readonly templateRef: TemplateRef<unknown>,
        private readonly viewContainerRef: ViewContainerRef,
    ) {}

    // eslint-disable-next-line @angular-eslint/prefer-signals
    @Input()
    public set hasSomePermissions(requiredPermissions: PermissionAliasEnum[]) {
        if (this.hasPermissionService.checkPermissions(requiredPermissions, OperatorEnum.OR)) {
            this.hasPermissionService.showComponent(this.viewContainerRef, this.templateRef);

            return;
        }

        this.hasPermissionService.removeComponent(this.viewContainerRef);
    }
}
